﻿export default function () {


	//from inline on theme
	$(window).on('load', function () {
		var $container = $('.isotope-wrapper');
		if ($container.length) {
			$container.isotope({ itemSelector: '.isotope-item', layoutMode: 'masonry' });
		}
	});
	$('.isotope_filter').on('click', 'a', 'change', function () {
		var selector = $(this).attr('data-filter');
		$('.isotope-wrapper').isotope({ filter: selector });
	});

}    